import { render } from "./FooterField.vue?vue&type=template&id=eb749aa8"
import script from "./FooterField.vue?vue&type=script&lang=js"
export * from "./FooterField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__